import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'lib-section-data-failure-error',
  imports: [MatIconModule],
  templateUrl: './section-data-failure-error.component.html',
  styleUrl: './section-data-failure-error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionDataFailureErrorComponent {}
